import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-CIvoire",
  "use": "icon-CIvoire-usage",
  "viewBox": "0 0 1529 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1529 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-CIvoire\"><path d=\"M4.047812 2.505788h507.843764v1014.434636H4.047812z\" fill=\"#F88000\" p-id=\"86303\" /><path d=\"M510.638682 2.505788h507.843765v1014.434636H510.638682z\" fill=\"#FFFFFF\" p-id=\"86304\" /><path d=\"M1018.482447 2.505788h507.843765v1014.434636H1018.482447z\" fill=\"#009E60\" p-id=\"86305\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol